import { useEffect } from 'react';
import { useSearchStateHits, useSearchStateHitsDispatch } from './useSearchStateHits';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';

const PAGE_SIZE = 16;

// have to get hundreds of results from algolia to show cluster markers.
// so have to do pagination on client side.
// TODO: probably should be added to url
const useSearchPagination = () => {
	const { hits } = useInfiniteHits( );
	const { page } = useSearchStateHits();
	const dispatch = useSearchStateHitsDispatch();

	// since hits are already retrieved, this doesn't hit algolia state to update the url
	useEffect( () => {
		if ( page === 1 ) {
			return;
		}

		const url = new URL( window.location.href );
		url.searchParams.set( 'page', page );
		window.history.pushState( window.history.state, null, url );
	}, [ page ] );

	const showMore = () => {
		dispatch( {
			type: 'nextPage',
		} );
	};

	return {
		hitsForPage: hits.slice( 0, page * PAGE_SIZE ),
		isLastPage: hits.length <= page * PAGE_SIZE,
		showMore,
		page,
	};
};

export default useSearchPagination;
